var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileMedia({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19 2h-12c-0.6 0-1 0.4-1 1v5l-2 3.4v9.6c0 0.5 0.5 1 1 1h14c0.5 0 1-0.5 1-1v-18c0-0.6-0.5-1-1-1zm-9 6h-2v-4h2zm4 0h-2v-4h2zm4 0h-2v-4h2z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileMedia);
export default __webpack_public_path__ + "static/media/file-media.3157d7698031af05384565ba02cd5969.svg";
export { ForwardRef as ReactComponent };